var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row flex-grow" }, [
    _c("div", { staticClass: "col-lg-10 mx-auto" }, [
      _c("div", { staticClass: "auth-form-light text-left pl-5 pr-5 pb-5" }, [
        _c("div", { staticClass: "brand-logo text-right" }, [
          _c("img", {
            attrs: {
              src: "/media/aform-logo-black.png",
              alt: "Coachingclub.lu"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n                    This waiver and release of liability includes, without limitation, all injuries which may occur, regardless of negligence, as a result of;\n                    (a) your use of equipment delivered by AFORM and your participation in any activity, workout, program, personal training or instruction,\n                    (b) the sudden and unforeseen malfunctioning of any equipment (c) our instruction, training, supervision, or dietary recommendations and (d) any online or virtual training.\n                "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              '\n                    You acknowledge that you have carefully read this "waiver and release" and fully understand that it is a release of liability.\n                    You expressly agree to release and dischargeAFORM s.à r.l. and all affiliates, employees, coaches, representatives, successors, or assigns, from any\n                    and all claims or causes of action and you agree to voluntarily give up or waive any right that you may otherwise have\n                    to bring a legal action against AFORM for negligence, personal injury or property damage.\n                '
            )
          ]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _vm._m(6),
          _vm._v(" "),
          _vm._m(7),
          _vm._v(" "),
          _vm._m(8),
          _vm._v(" "),
          _vm._m(9),
          _vm._v(" "),
          _vm._m(10),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-primary cursor-pointer",
                    attrs: { tag: "a", to: { name: "login" } }
                  },
                  [
                    _vm._v(
                      "\n                            Home\n                        "
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(11)
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("TERMS AND CONDITIONS:")]),
      _c("br"),
      _vm._v(
        "\n                    By beginning this AFORM program, you agree to the following terms and conditions.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("PHYSICAL CONDITION & INJURY:")]),
      _c("br"),
      _vm._v(
        " Because physical exercise can be strenuous and subject to risk of serious injury,\n                    AFORM urges you to obtain a physical examination from a doctor before using any exercise equipment or participating in any exercise activity.\n                    You (each member, guest, or participant) agree that if you engage in any physical exercise or activity, you do so entirely at your own risk.\n                    You agree that you are voluntarily participating in these activities, training sessions and workouts and assume all risks of injury, illness, or death.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("PAYMENT & FEES:")]),
      _c("br"),
      _vm._v(
        " All purchases of the AFORM online membership are NON-REFUNDABLE unless otherwise stated in writing by AFORM s.à r.l. Manager Jeff Paulus.\n                    Users must cancel their account by logging into the platform and opt to cancel prior to their next monthly billing cycle if they do not wish to continue.\n                    AFORM is not responsible for canceling user subscriptions, and is not required to provide refunds if a user fails to do so.\n                    By purchasing access to the AFORM OnlineCoaching Club you agree to the above verbiage.\n                    The above aforementioned programs require a recurring payment of 29,00€ per month or 24,00€ per month in the second year of membership.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("PROGRAM ACCESS:")]),
      _c("br"),
      _vm._v(
        " AFORM Online Coaching Club is not a physical product.\n                    AFORM online content can be accessed through a secure website/app after the consumer has completed purchased and has created their unique username and password combination.\n                    This content cannot be accessed or distributed via any other method.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("EQUIPMENT:")]),
      _c("br"),
      _vm._v(
        " Our goal is to have only satisfied customers.\n                    If you find any piece of equipment delivered unsatisfactory in any way, please send a mail to the AFORM general inbox; office@aform.lu and an AFORM member will do his best to assist.\n                    Any piece of equipment delivered by AFORM must be returned in unused condition to receive full credit.\n                    AFORM cannot be held accountable for lost, stolen or damaged packages. AFORM is not responsible for any piece of equipment that is lost or damaged.\n                    AFORM will not refund any costs. We do our best to deliver the equipment within the first month of membership.\n                    We deliver anywhere in Luxembourg, but only in Luxembourg.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("AGE:")]),
      _c("br"),
      _vm._v(
        " If the participant of any AFORM online content is under 18 years of age, these Terms and Conditions MUST\n                    be accepted (on the participant’s behalf) by the participant’s parent or legal guardian.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("DISCUSSION AND QUESTIONS:")]),
      _c("br"),
      _vm._v(
        " All users are to post respectable content within the platform.\n                    Inappropriate content within the community platform will not be tolerated, and failure to adhere to these standards will result in immediate cancellation\n                    of access to the online platform. AFORM Online Coaching Club content is not a personalized platform, however the possibility\n                    to exchange and discuss is available for users and AFORM staff members engage to respond to general online questions.\n                    AFORM is not liable for any unanswered posts or questions, nor does AFORM guarantee to provide specific 1:1 personal coaching.\n                    A good faith effort will be made on behalf of AFORM to address as many content-related questions as possible,\n                    and cannot by law provide medical or legal advice of any sort. Online clients are welcome to submit any unanswered discussion forum questions to the AFORM general inbox; office@aform.lu\n                    and an AFORM member will do their best to assist.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("ACCOUNT SECURITY:")]),
      _c("br"),
      _vm._v(
        " You are responsible for maintaining the confidentiality of your username and password and will be held fully liable\n                    for all activities that occur under your username and password. You shall immediately notify us of any unauthorized use of your username or password or any other breach of security.\n                    AFORM will not be liable for any loss or damage arising from your failure to comply with this provision.\n                    You should use particular caution when accessing your account from a public or shared computer to decrease the risk of others being able to view or record your password\n                    or other personal information.\n                    Additionally, your account cannot be shared for multiple user access, if such activity takes\n                    place you will be held fully accountable by law unless granted written consent from AFORM.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("LIMITATIONS ON USE:")]),
      _c("br"),
      _vm._v(
        " AFORM grants to you a limited personal, non-exclusive and nontransferable\n                    right and license to access the site and/or content. Unless otherwise specified in writing, the site and/or content are for your personal and non-commercial use.\n                    The site and/or content including (without limitation) the content, metadata, design, organization, compilation, look and feel, workout plans,\n                    exercises/programs, workout videos, coaching videos and all other protectable intellectual property available through the site and/or content (the “proprietary materials”)\n                    solely belong to AFORM ́s property, or the property of our licensors, and are protected by copyright and other intellectual property laws.\n                    All rights regarding the proprietary materials not expressly granted in this agreement are reserved by AFORM.\n                    You may not copy, reproduce, sell, publish, distribute, display, retransmit or otherwise provide access to the proprietary materials received through the site to anyone without written consent.\n                    You agree not to rearrange, modify or create derivative works using the proprietary materials. You agree not to create, scrape or display our content\n                    for use on another web site or service without AFORM’s written consent. You agree not to post any content from AFORM Online Coaching Club to weblogs,\n                    social media, YouTube, news groups, mail lists or electronic bulletin boards without our written consent.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("MEDIA RELEASE:")]),
      _c("br"),
      _vm._v(
        " By agreeing to these terms and conditions,\n                    you authorize AFORM the right to post all member photos/videos *if applicable*, and discussions on social media outlets,\n                    websites and any other platform that AFORM deems necessary.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("MODIFICATIONS TO AGREEMENT:")]),
      _c("br"),
      _vm._v(
        " AFORM reserves the right at any time to modify this Agreement and to impose new or additional terms or conditions on\n                    your use of the online content and services. Such modifications and additional terms and conditions will be effective immediately\n                    and incorporated into this Agreement. Your continued use of the online content and services will be deemed acceptance thereof.\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6 text-right" }, [
      _c("p", [_c("i", [_vm._v("Last update: 09.10.2020")])])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }